import React from 'react';
import {
  Box,
  Paper,
  Skeleton,
  Collapse,
  Divider,
} from '@mui/material';

const NfeDetailsSkeleton = ({ visible }) => {
  return (
    <Collapse in={visible} timeout={500}>
      <Paper
        elevation={2}
        sx={{
          p: { xs: 2, md: 3 },
          mb: { xs: 2, md: 3 },
          backgroundColor: "#fff",
          border: "1px solid rgba(255, 152, 0, 0.3)",
          boxShadow: "0 4px 12px rgba(255, 152, 0, 0.15)",
          borderRadius: 2,
          minHeight: 580,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: { xs: 2, md: 3 },
            flexWrap: "wrap",
            gap: { xs: 1, md: 2 },
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Skeleton variant="circular" width={24} height={24} />
            <Skeleton variant="text" width={200} height={32} />
          </Box>
          <Skeleton 
            variant="rectangular" 
            width={90} 
            height={36} 
            sx={{ borderRadius: 2 }} 
          />
        </Box>

        <Divider sx={{ mb: { xs: 2, md: 3 } }} />

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 2, md: 3 } }}>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                sm: 'repeat(2, 1fr)',
                md: 'repeat(3, 1fr)',
              },
              gap: { xs: 1.5, md: 2 },
            }}
          >
            {[1, 2, 3].map((item) => (
              <Paper
                key={item}
                variant="outlined"
                sx={{
                  p: { xs: 1.5, md: 2 },
                  borderRadius: { xs: 1.5, md: 2 },
                  height: { xs: 90, md: 100 },
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  transition: 'all 0.2s ease-in-out',
                }}
              >
                <Skeleton variant="text" width="50%" height={14} />
                <Skeleton variant="text" width="85%" height={28} />
              </Paper>
            ))}
          </Box>

          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                sm: 'repeat(2, 1fr)',
              },
              gap: { xs: 1.5, md: 2 },
            }}
          >
            {[1, 2].map((item) => (
              <Paper
                key={item}
                variant="outlined"
                sx={{
                  p: { xs: 1.5, md: 2 },
                  borderRadius: { xs: 1.5, md: 2 },
                  height: { xs: 90, md: 100 },
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  transition: 'all 0.2s ease-in-out',
                }}
              >
                <Skeleton variant="text" width="50%" height={14} />
                <Skeleton variant="text" width="75%" height={28} />
              </Paper>
            ))}
          </Box>

          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                sm: 'repeat(2, 1fr)',
              },
              gap: { xs: 1.5, md: 2 },
            }}
          >
            {[1, 2].map((item) => (
              <Paper
                key={item}
                variant="outlined"
                sx={{
                  p: { xs: 1.5, md: 2 },
                  borderRadius: { xs: 1.5, md: 2 },
                  height: { xs: 90, md: 100 },
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  transition: 'all 0.2s ease-in-out',
                }}
              >
                <Skeleton variant="text" width="50%" height={14} />
                <Skeleton variant="text" width="75%" height={28} />
              </Paper>
            ))}
          </Box>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'stretch',
              gap: 2.5,
              mt: { xs: 2, md: 4 },
              p: { xs: 2, md: 3 },
              background: 'linear-gradient(90deg, #fff 80%, #fffbe6 100%)',
              borderRadius: 3,
              boxShadow: '0 2px 8px rgba(255, 152, 0, 0.07)',
              border: '1px solid rgba(255, 152, 0, 0.13)',
              minHeight: 120,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                mb: 2,
                width: '100%',
              }}
            >
              <Box sx={{ 
                flex: 3, 
                minWidth: 180,
                display: 'flex', 
                alignItems: 'center', 
                gap: 1 
              }}>
                <Skeleton variant="circular" width={24} height={24} />
                <Skeleton variant="text" width="65%" height={32} />
              </Box>
              <Box sx={{ 
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                minWidth: 120,
                maxWidth: 320,
              }}>
                <Skeleton variant="text" width="50%" height={20} sx={{ mb: 1 }} />
                <Skeleton 
                  variant="rectangular" 
                  width="100%" 
                  height={60} 
                  sx={{ borderRadius: 2 }} 
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Paper>
    </Collapse>
  );
};

export default NfeDetailsSkeleton;